module.exports = __webpack_public_path__ + "static/media/tutorial-macros-pin.4dc08881.svg";